import { inject } from '@angular/core';
import { ConfigInstanceToken } from '@evorait/pace-core';
import { CanActivateFn, Router } from '@angular/router';

export const SmartlockerCanActivateGuard: CanActivateFn = () => {
    const configService = inject(ConfigInstanceToken);
    if (configService.getEnableSmartlocker()) {
        return true;
    }

    const router = inject(Router);
    return router.navigate(['/main']);
};
